import { render, staticRenderFns } from "./Pemaparan.vue?vue&type=template&id=4bd4a857"
import script from "./Pemaparan.vue?vue&type=script&lang=js"
export * from "./Pemaparan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports